import {
    FrontendFilter,
    FrontendFilterGroup,
    FrontendFilterInputBooleanSelect, FrontendFilterInputSelectOneWithSearch, FrontendFilterOption,
    FrontendFilterResultColumn,
    FrontendFilterResultRowModifier,
    FrontendFilterResultRowModifierCssClasses
} from "@/components/FrontendFilters/structs";
import {Route} from "vue-router";
import Vue from "vue";
import {getDisplayTextForApiLog} from "@/views/OrderDetail/FrontendFiltersOrderEventSearchFunctions";

export default class FrontendFiltersOrderEventSearch implements FrontendFilterGroup {

    identifier = 'order-events'
    subIdentifier = 'default';

    pageTitleLanguageKey = '';
    pageIcon = '';

    hideFilterCard = false;

    searchApiPath = (route: Route) => `/api/rest/sales-orders/${route.params.salesOrderIdentifier}/triggers`;

    resultsPerPage = 1000;

    resultRowPreprocessor = (resultRow: Record<string,any>): Record<string,any> => {
        if (resultRow.event.source !== 'trigger') {
            const displayText = getDisplayTextForApiLog(resultRow);
            resultRow.computed = {
                description: displayText[0],
                action: displayText[1],
            }
        }
        return resultRow;
    };
    resultRowModifiers = [
        () => new FrontendFilterResultRowModifier(
            (resultRow) => resultRow.event.parent_id,
            FrontendFilterResultRowModifierCssClasses.highlight,
        ),
    ];

    batchActions = [];

    // De lijst van beschikbare filters
    filters = [
        new FrontendFilter(
            'source',
            new FrontendFilterInputSelectOneWithSearch(),
            () => Promise.resolve([
                new FrontendFilterOption('api', 'API aanroep'),
                new FrontendFilterOption('trigger', 'Trigger'),
                new FrontendFilterOption('gui', 'Handmatige actie'),
            ]),
        ),
        new FrontendFilter(
            'success',
            new FrontendFilterInputBooleanSelect(),
        ),
    ];

    columns = [
        new FrontendFilterResultColumn(
            'id',
            (resultRow) => resultRow.event.id.toString(),
        ),
        new FrontendFilterResultColumn(
            'parent_id',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueParentId', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueParentId.vue') as object)
        ),
        new FrontendFilterResultColumn(
            'executed_at',
            (resultRow) => resultRow.event_result?.created_at ?? resultRow.event.created_at,
        ),
        new FrontendFilterResultColumn(
            'user_name',
            (resultRow) => resultRow.event.user_name ?? 'systeem',
        ),
        new FrontendFilterResultColumn(
            'source',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueSource', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueSource.vue') as object),
            undefined,
            'source',
        ),
        new FrontendFilterResultColumn(
            'description',
            (resultRow) => resultRow.computed?.description ?? resultRow.trigger?.description,
        ),
        new FrontendFilterResultColumn(
            'action',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueAction', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueAction.vue') as object),
        ),
        new FrontendFilterResultColumn(
            'trigger_id',
            (resultRow) => resultRow.trigger?.id,
        ),
        new FrontendFilterResultColumn(
            'trigger_action_id',
            (resultRow) => resultRow.trigger_action?.id,
        ),
        new FrontendFilterResultColumn(
            'success',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueSuccess', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueSuccess.vue') as object),
            undefined,
            'success',
        ),
        new FrontendFilterResultColumn(
            'extra_info',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueExtraInfo', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueExtraInfo.vue') as object),
        ),
        new FrontendFilterResultColumn(
            'buttons',
            // @ts-ignore
            (resultRow) => Vue.component('ColumnValueButtons', () => import('@/views/OrderDetail/FrontendFilterEventResultColumnValues/ColumnValueButtons.vue') as object),
        ),
    ];
}
